import React, { useState } from "react";
import "../styles/App.css";
import { useLanguage } from "../context/LanguageContext";

const Places = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useLanguage();
  const tp = t.places;

  const toggleQuestion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const icons = ["family", "cash", "time", "friends", "free", "cars"];
  const safetyIcons = ["security", "file", "headphone"];

  return (
    <>
      <div className="hero-sec">
        <div className="hero-text">
          <h1>{tp.heroTitle}</h1>
          <p>{tp.heroSubtitle}</p>
          <a href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1">
            <button className="ridees">{tp.signUpToRide}</button>
          </a>
        </div>
        <div className="all-images">
          <img src="/images/home.jpg" alt="Hero" className="hero-image" />
        </div>
      </div>

      <div className="berymo-containers">
        <h2>{tp.whyRideTitle}</h2>
        <p className="berymo-subtexts">{tp.whyRideSubtitle}</p>
        <div className="berymo-grids">
          {tp.features.map((item, i) => (
            <div className="berymo-box" key={i}>
              <img src={`/images/${icons[i]}.png`} alt={icons[i]} className="icon" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="berymo-video-container">
        <video className="berymo-video" src="/vedio/food.mp4" autoPlay muted loop />
      </div>

      <div className="berymo-container">
        <h2>{tp.safetyTitle}</h2>
        <p className="berymo-subtext">{tp.safetySubtitle}</p>
        <div className="berymo-grid">
          {tp.safetyFeatures.map((item, i) => (
            <div className="berymo-box" key={i}>
              <img src={`/images/${safetyIcons[i]}.png`} alt={safetyIcons[i]} className="icon" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="faq-sections">
        <h1>{tp.faqTitle}</h1>
        <div className="faq-lists">
          {tp.faq.map((item, index) => (
            <div key={index} className="faq-items" onClick={() => toggleQuestion(index)}>
              <div className="faq-questions">
                <span>{item.question}</span>
                <span className="plus-icon">{activeIndex === index ? "×" : "+"}</span>
              </div>
              <div className={`faq-answers ${activeIndex === index ? "open" : ""}`}>
                <div className="faq-steps">{item.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="signup-section">
        <h1>{tp.ctaTitle}</h1>
        <p>{tp.ctaSubtitle}</p>
        <a href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1">
          <button className="ride">{tp.signUpToRide}</button>
        </a>
      </div>
    </>
  );
};

export default Places;
